import {IterativeSystem} from "tick-knock";
import {Building} from "@game/coregame/ecs/entities/Building";
import {AllBuildingsQuery} from "@game/coregame/ecs/queries/AllBuildingsQuery";
import {PathHolder} from "@game/coregame/ecs/components/PathHolder";
import {Vector2} from "@game/coregame/interfaces/Vector2";
import {PathNode} from "@game/coregame/interfaces/PathNode";
import {CapitalView} from "@game/coregame/view/CapitalView";
import {math as v} from "@game/coregame/helpers/math";

export class PathsGenerationSystem extends IterativeSystem {
    constructor() {
        super(entity => entity.has(CapitalView));
    }

    update(dt: number) {
        super.update(dt);
        this.engine.removeSystem(this); // generate and die
    }

    protected updateEntity(entity: Building, dt: number) {
        const pathHolder: PathHolder | undefined = entity.get(PathHolder);
        if (pathHolder) {
            pathHolder.clearCache();
            for (const building of this.entities as Building[]) {
                if (building == entity) {
                    continue;
                }
                const target = building.data.statePos;
                const self = entity.data.statePos;
                const offset = building.data.stateRadius * 0.5;
                const worldPath: Vector2[] = [];
                const dir = v.norm(v.sub(target, self));

                worldPath.push(self);
                worldPath.push(v.sum(self, v.scale(dir, offset)));
                worldPath.push(v.sub(target, v.scale(dir, offset)));
                worldPath.push(target);

                const path: PathNode[] = [];
                path.push([self, self]);
                const w = PathHolder.MAX_SPAWN_LEN_ONE_DIRECTION;
                // burst
                for (let i = 1; i < worldPath.length - 1; i++) {
                    // get dir
                    const forwardDir = v.norm(v.sub(worldPath[i + 1], worldPath[i]));
                    const rightDir = v.rotate(forwardDir, -Math.PI / 2);
                    const leftDir = v.rotate(forwardDir, Math.PI / 2);
                    const right = v.sum(worldPath[i], v.scale(rightDir, w));
                    const left = v.sum(worldPath[i], v.scale(leftDir, w));

                    path.push([right, left]);
                }
                path.push([target, target]);

                pathHolder!.addPath(building, path);
            }
        }
    }
}
